import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const ReferralFraudRBAC = {
  pageID: 'e7228ef9338bc6e3cbf18d1d29a4c2d0',
  elementID: {
    ViewPage: '2d8fce0f00479d54b362198fb187c416',
    ActionToggleRelease: '6a589c2b5c81bb1771ecdf7d3895135a',
  },
} as const

export const useRBACReferralFraudPage = createUseRBAC(ReferralFraudRBAC.elementID)
export type UseRBAWatchtowerRuleListPageType = ReturnType<typeof useRBACReferralFraudPage>
